var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20007 1.09961H10.8001C12.7799 1.09961 13.7699 1.09961 14.385 1.71469C15.0001 2.32976 15.0001 3.31971 15.0001 5.29961V6.69961C15.0001 8.67949 15.0001 9.66943 14.385 10.2845C13.7699 10.8996 12.7799 10.8996 10.8001 10.8996H5.20007",
    stroke: "#172B4D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 3.89844C2.67521 4.31133 1 5.41023 1 5.99844C1 6.58665 2.67521 7.68558 3.1 8.09844",
    stroke: "#172B4D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92224 3.89844C8.347 4.31133 10.0222 5.41023 10.0222 5.99844C10.0222 6.58665 8.347 7.68558 7.92224 8.09844",
    stroke: "#172B4D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6H9.39999",
    stroke: "#172B4D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.0a74d64eabf61d931bf65327a523ec0f.svg";
export { ForwardRef as ReactComponent };